import React, {Component} from "react"
import PropTypes from "prop-types"
import Icon from "../../atoms/Icon"
import Button from '../../atoms/Button';

class ManageAgendaAccommodation extends Component {
  render() {
    const that = this
    const {
      dayId,
      accommodationRequired,
      rooms,
      people,
      updateAccommodation,
    } = this.props

    const peopleSorted = Object.keys(people || {})
      .map(personId => {
        return {
          ...people[personId],
          personId,
        }
      })
      .sort((a, b) => {
        if (a.name === b.name) return 0
        return a.name > b.name ? 1 : -1
      })

    const addRoom = () => {
      this.props.addRoom(dayId)
    }

    return (
      <div className="ManageAgendaAccommodation">
        <div>
          <label>Accommodation organised for this day?</label>
          <input
            type="checkbox"
            name="accommodationRequired"
            checked={accommodationRequired}
            onChange={updateAccommodation}
          />
        </div>
        {accommodationRequired &&
          <div>
            <div className="AgendaDay-Accommodation">
              {Object.keys(rooms || {}).map((roomId, index) => {
                const room = rooms[roomId]

                const removeRoom = () => {
                  that.props.removeRoom(dayId, roomId)
                }

                const addPerson = ev => {
                  that.props.addPerson(dayId, roomId, ev.target.value)
                }

                if (room === null) return null

                return (
                  <div className="AgendaDay-Room" key={roomId}>
                    <h6>
                      Room #{index}
                      <Button type="delete" onClick={removeRoom}>
                        <Icon icon="trash-empty" />
                      </Button>
                    </h6>
                    <ul>
                      {room.map(personId => {
                        const removePerson = () => {
                          that.props.removePerson(dayId, roomId, personId)
                        }

                        return (
                          <li className="person" key={personId}>
                            {people[personId].name}
                            <Button type="delete" small onClick={removePerson}>
                              <Icon icon="trash-empty" />
                            </Button>
                          </li>
                        )
                      })}
                      <li>
                        <select onChange={addPerson}>
                          <option value={null}>-- Select to add --</option>
                          {peopleSorted.map(person => {
                            const {personId, name} = person
                            let roomId
                            if (room.indexOf(personId) > -1) return null
                            for (roomId in rooms) {
                              if (
                                rooms &&
                                rooms[roomId] &&
                                rooms[roomId].indexOf(personId) > -1
                              )
                                return null
                            }
                            return (
                              <option key={personId} value={personId}>
                                {name}
                              </option>
                            )
                          })}
                        </select>
                      </li>
                    </ul>
                  </div>
                )
              })}
            </div>
            <div className="controls">
              <Button onClick={addRoom}> Add Room </Button>
            </div>
          </div>}
      </div>
    )
  }
}

ManageAgendaAccommodation.defaultProps = {
  accommodationRequired: false,
  rooms: {},
  people: {},
}

ManageAgendaAccommodation.propTypes = {
  accommodationRequired: PropTypes.bool.isRequired,
  rooms: PropTypes.object.isRequired,
  people: PropTypes.object.isRequired,
  updateAccommodation: PropTypes.func.isRequired,
  addRoom: PropTypes.func.isRequired,
  removeRoom: PropTypes.func.isRequired,
  addPerson: PropTypes.func.isRequired,
  removePerson: PropTypes.func.isRequired,
}

export default ManageAgendaAccommodation



// WEBPACK FOOTER //
// ./src/component/organisms/ManageAgenda/ManageAgendaAccommodation.js